import { render, staticRenderFns } from "./BdAside.vue?vue&type=template&id=3886bec8&scoped=true&"
import script from "./BdAside.vue?vue&type=script&lang=js&"
export * from "./BdAside.vue?vue&type=script&lang=js&"
import style0 from "./BdAside.vue?vue&type=style&index=0&id=3886bec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3886bec8",
  null
  
)

export default component.exports